import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import LoadingButton from '@atlaskit/button/loading-button';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
export const PrimaryCTAContainer = _styled("div", {
  target: "eucncv10",
  label: "PrimaryCTAContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "17gow3k",
  styles: "min-width:106px;"
} : {
  name: "17gow3k",
  styles: "min-width:106px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9QcmltYXJ5Q1RBLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1CNkMiLCJmaWxlIjoiLi4vc3JjL1ByaW1hcnlDVEEuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuXG5pbXBvcnQgTG9hZGluZ0J1dHRvbiBmcm9tICdAYXRsYXNraXQvYnV0dG9uL2xvYWRpbmctYnV0dG9uJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgUmVhY3QsIHsgUHVyZUNvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHR5cGUgeyBOb2RlIH0gZnJvbSAncmVhY3QnO1xuXG50eXBlIFByb3BzID0ge1xuICBjaGlsZHJlbjogTm9kZSxcbiAgaHJlZj86IHN0cmluZyxcbiAgaXNEaXNhYmxlZDogYm9vbGVhbixcbiAgaXNMb2FkaW5nOiBib29sZWFuLFxuICBvbkNsaWNrPzogKFN5bnRoZXRpY0V2ZW50PEhUTUxMaW5rRWxlbWVudD4pID0+IHZvaWQsXG4gIGJ1dHRvbklkPzogc3RyaW5nLFxuICB0ZXN0SWQ/OiBzdHJpbmcsXG59O1xuXG5leHBvcnQgY29uc3QgUHJpbWFyeUNUQUNvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIG1pbi13aWR0aDogMTA2cHg7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBQcmltYXJ5Q1RBIGV4dGVuZHMgUHVyZUNvbXBvbmVudDxQcm9wcz4ge1xuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIGNoaWxkcmVuOiBQcm9wVHlwZXMubm9kZS5pc1JlcXVpcmVkLFxuICAgIGhyZWY6IFByb3BUeXBlcy5zdHJpbmcsXG4gICAgaXNEaXNhYmxlZDogUHJvcFR5cGVzLmJvb2wsXG4gICAgaXNMb2FkaW5nOiBQcm9wVHlwZXMuYm9vbCxcbiAgICBvbkNsaWNrOiBQcm9wVHlwZXMuZnVuYyxcbiAgfTtcblxuICBzdGF0aWMgZGVmYXVsdFByb3BzID0ge1xuICAgIGlzRGlzYWJsZWQ6IGZhbHNlLFxuICAgIGlzTG9hZGluZzogZmFsc2UsXG4gIH07XG5cbiAgcmVuZGVyID0gKCkgPT4gKFxuICAgIDxQcmltYXJ5Q1RBQ29udGFpbmVyPlxuICAgICAgPExvYWRpbmdCdXR0b25cbiAgICAgICAgYXBwZWFyYW5jZT1cInByaW1hcnlcIlxuICAgICAgICBocmVmPXt0aGlzLnByb3BzLmhyZWZ9XG4gICAgICAgIGlzTG9hZGluZz17dGhpcy5wcm9wcy5pc0xvYWRpbmd9XG4gICAgICAgIGlzRGlzYWJsZWQ9e3RoaXMucHJvcHMuaXNEaXNhYmxlZH1cbiAgICAgICAgb25DbGljaz17dGhpcy5wcm9wcy5vbkNsaWNrfVxuICAgICAgICBzaG91bGRGaXRDb250YWluZXJcbiAgICAgICAgaWQ9e3RoaXMucHJvcHMuYnV0dG9uSWR9XG4gICAgICAgIHRlc3RJZD17dGhpcy5wcm9wcy50ZXN0SWR9XG4gICAgICA+XG4gICAgICAgIHt0aGlzLnByb3BzLmNoaWxkcmVufVxuICAgICAgPC9Mb2FkaW5nQnV0dG9uPlxuICAgIDwvUHJpbWFyeUNUQUNvbnRhaW5lcj5cbiAgKTtcbn1cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export default class PrimaryCTA extends PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => /*#__PURE__*/React.createElement(PrimaryCTAContainer, null, /*#__PURE__*/React.createElement(LoadingButton, {
      appearance: "primary",
      href: this.props.href,
      isLoading: this.props.isLoading,
      isDisabled: this.props.isDisabled,
      onClick: this.props.onClick,
      shouldFitContainer: true,
      id: this.props.buttonId,
      testId: this.props.testId
    }, this.props.children)));
  }

}

_defineProperty(PrimaryCTA, "propTypes", {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func
});

_defineProperty(PrimaryCTA, "defaultProps", {
  isDisabled: false,
  isLoading: false
});